import { Sidebar } from '@/components/Layout';
import { useGlobalContextStore } from '@/store/GlobalContextStore/globalContextStore';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const { isSidebarOpen } = useGlobalContextStore();

  return (
    <div className="flex bg-bgColor">
      <div className="mr-5">
        <Sidebar />
      </div>
      <main
        className={`flex-1 mr-5 ${isSidebarOpen ? 'ml-[298px]' : 'ml-[92px]'} bg-bgColor transition-all duration-300`}
      >
        {children}
      </main>
    </div>
  );
};
